import React from "react";
import { AdvantageList } from "../../blocks/advantage-list";
import { CommonPageLink } from "../../blocks/common-page-link";
import { MultiplePageContent } from "../../blocks/multiple-content-features";
import { MultipleAdvantage } from "../../blocks/multiple-content-advantage";
import { useTranslation } from "react-i18next";
import { Header } from "../../components/Header";
import { ProductBanner } from "../../blocks/product-banner";
import { Footer } from "../../components/Footer";
import "./styles.less";
import { HomeTryOn } from "../../blocks/home-try-on";

export const MultiplePage = () => {
  const { t } = useTranslation();
  const bannerData = {
    title: "learn.mfaPage.banner.title",
    subTitle: "learn.mfaPage.banner.subtitle",
    bannerImg: {
      src: t("learn.mfaPage.banner.bannerImg"),
      // src: "//files.authing.co/authing-website/mfa-banner-img.png",
      alt: "authing employee-identity-manage",
    },
    bannerBG: {
      src: "//files.authing.co/authing-website/sso-banner-bg.png",
      alt: "authing",
    },
    hasButton: true,
    docLink: "https://docs.authing.cn/v2/guides/authentication/mfa/",
  };
  const advantageData = [...Array(3)].map((item, index) => {
    return {
      label: `learn.mfaPage.advantageData.${index}.label`,
      value: `learn.mfaPage.advantageData.${index}.value`,
    };
  });

  const pagesLink = [
    {
      title: t("common.pageLink.comp.title"),
      description: t("common.pageLink.comp.description"),
      imgurl: "/page-link-comp.png",
      jumpLink: "/learn/guard",
      defaultImg: "//files.authing.co/authing-website/page-link-icon-comp.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-comp.svg",
    },
    {
      title: t("common.pageLink.mfa.title"),
      description: t("common.pageLink.mfa.description"),
      imgurl: "/page-link-mfa.png",
      jumpLink: "/mfa",
      defaultImg: "//files.authing.co/authing-website/page-link-icon-mfa.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-mfa.svg",
    },
    {
      title: t("common.pageLink.verify.title"),
      description: t("common.pageLink.verify.description"),
      imgurl: "/page-link-verify.png",
      jumpLink: "/verify",
      defaultImg:
        "//files.authing.co/authing-website/page-link-icon-verify.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-verify.svg",
    },
    {
      title: t("common.pageLink.database.title"),
      description: t("common.pageLink.database.description"),
      imgurl: "/page-link-database-connection.png",
      jumpLink: "/database-connection",
      defaultImg:
        "//files.authing.co/authing-website/page-link-icon-database.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-database.svg",
    },
  ];

  return (
    <div className="mfa_page">
      <Header mode="light" />
      <ProductBanner {...bannerData} />
      <AdvantageList advantageData={advantageData} position="bottom" />
      <MultiplePageContent />
      <MultipleAdvantage />
      <CommonPageLink pagesLink={pagesLink} />
      <div className="mfaPage-homeTryOn-bg">
        <HomeTryOn />
      </div>
      <Footer />
    </div>
  );
};
